<template>
  <div @click="onInput">
    <slot v-bind="{ selected: modelValue }" />
  </div>
</template>

<script setup lang="ts" generic="T extends string | number | boolean">
import type { PropType } from '@/composition/vue/compositionApi'
import { fieldProps } from '@/components/forms/fieldBase'
import { DefaultInputEvent, fieldEmits } from '@/services/forms/types'

const props = defineProps({
  ...fieldProps,
  modelValue: {
    type: [String, Number, Boolean] as PropType<T>,
  },
  val: {
    type: [String, Number, Boolean] as PropType<T>,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(fieldEmits<T>())

function onInput() {
  const value = props.val
  if (value === undefined) {
    return
  }
  if (!props.disabled) {
    emit(DefaultInputEvent, value as T)
  }
}
</script>
